import { RequestMethods } from './types';

/** Available requests methods. */
export const REQUEST_METHODS: RequestMethods = {
  GET: 'GET',
  DELETE: 'DELETE',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH'
};
